import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createDashboardUser = async (token, params) => {
  const objectName = 'dashboard_user'
  const url = `dashboards/${params.dashboard_id}/dashboard_users`

  await apiPost({ url, token, objectName, params })
}

export function useCreateDashboardUser({ params, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => {
      return createDashboardUser(token, params)
    },
    { ...options }
  )
}

const destroyDashboardUser = async (token, id) => {
  const url = `dashboard_users/${id}`

  await apiDelete({ url, token })
}

export function useDestroyDashboardUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => {
      return destroyDashboardUser(token, id)
    },
    { ...options }
  )
}

const updateDashboardUser = async (token, id, params) => {
  const objectName = 'dashboard_user'
  const url = `dashboard_users/${id}`

  return await apiPatch({ url, token, objectName, params })
}

export function useUpdateDashboardUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    (params) => {
      return updateDashboardUser(token, id, params)
    },
    { ...options }
  )
}

